import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { Modal } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import Switch from "react-switch";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import countries from "../../../utils/countries";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';
const { RangePicker } = DatePicker;

const statusList = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "KYC Verified", value: "verified" }
];

const packageList = [
    { label: '500 - 4,999', value: 1, min: 500, max: 4999, low_roi: '3', high_roi: '6' },
    { label: '5,000 and above', value: 2, min: 5000, max: 0, low_roi: '7', high_roi: '12' },
]

const MemberDetails = (props) => {
    const dispatch = useDispatch();
    const [memberList, setMemberList] = useState([]);
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    const [passwordModal, setPasswordModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [rankList, setRankList] = useState([]);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [modal, setModal] = useState(false);
    const [buttonStatus, setButtonStatus] = useState("Cancel");
    const [trxModal, setTrxModal] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [mt5AccountModal, setMt5AccountModal] = useState(false);
    const [walletAddressModal, setWalletAddressModal] = useState(false);
    const [groupEmail, setGroupEmail] = useState('');

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showTrxPassword, setShowTrxPassword] = useState(false);
    const [purchaseModal, setPurchaseModal] = useState(false);
    const [adjustCommModal, setAdjustCommModal] = useState(false);
    const [showConfirmTrxPassword, setShowConfirmTrxPassword] = useState(false);
    const [topupWalletModal, setTopupWalletModal] = useState(false);
    const timerRef = useRef(null);
    const [addMemberModal, setAddMemberModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);

    const [formData, setFormData] = useState({
        nickName: '',
        username: '',
        trxPassword: '',
        confirmTrxPassword: '',
        email: '',
        role: '',
        id: '',
        referralCode: '',
        sponsorName: '',
        phoneNo: '',
        dob: '',
        ranking: '',
        remark: '',
        status: '',
        country: '',
        password: "",
        confirmPassword: "",
        created_at: "",
        dob: "",
        address: "",
        full_name: "",
        productPerpage: 10,
        packageId: "",
        totalProfit: 0,
        totalCommission: 0,
        status: '',
        company_customer_profit_sharing_id: '',
    });
    let errorsObj = { max_lot_per_month: '', package_id: '', total_trade_profit: '', total_commission_profit: '', nickName: '', confirmTrxPassword: '', trxPassword: '', sponsorName: '', dob: '', phoneNo: '', ranking: '', country: '', password: '', confirmPassword: "", full_name: "", totalCommission: "", totalProfit: "", company_customer_profit_sharing_id: '', amount: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [loadingModal, setLoadingModal] = useState(false);
    const [customRankList, setCustomRankList] = useState([]);
    const [firstLoad, setFirstLoad] = useState(true);
    const [purchaseFormData, setPurchaseFormData] = useState({
        amount: '',
        type: 'create',
        customer_mt5_id: '',
        package_id: '',
    })
    const [topupWalletFormData, setTopupWalletFormData] = useState({
        package_id: '',
        amount: '',
    })
    const [profitFormData, setProfitFormData] = useState({
        total_trade_profit: '',
        total_commission_profit: '',
    })

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getMemberDetails(event.selected + 1);
    }

    useEffect(() => {
        if (firstLoad) {
            getMemberDetails();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getMemberDetails(1);
        }
    }, [email, productPerpage, from, to, status, groupEmail, props.lang]);

    useEffect(() => {
        getRank();
    }, [])

    const handleDOBChange = (date) => {
        if (date) {
            const formattedDate = dayjs(date).format("YYYY-MM-DD");
            const newFormData = { ...formData };
            newFormData["dob"] = formattedDate;
            setFormData(newFormData);
        } else {
            const newFormData = { ...formData };
            newFormData["dob"] = '';
            setFormData(newFormData);
        }
    }

    const switchStatus = (id, status) => {
        if (status.toLowerCase() === "active" || status.toLowerCase() === "verified") {
            status = "inactive"
        } else {
            status = "active"
        }

        let data = {
            "status": status
        }
        fetch(api.admin + `/edit_customer_status/${id}`, {
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token

            }),
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(responseJson => {
                setLoading(false);
                if (responseJson.status === "success") {
                    swal(translate(props.lang, 'Success'), responseJson.message, "success");
                    getMemberDetails();
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    swal(translate(props.lang, "Error"), responseJson.message, "error");
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const getMemberDetails = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_customers + `?page=${page}&sort_by=customer_id&order_by=DESC`
        if (email) {
            url += `&email=${email}`;
        }
        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (status) {
            url += `&status=${status}`
        }
        if (groupEmail) {
            url += `&group_email=${groupEmail}`
        }

        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setPageCount(pageCount);
                    setTotalResultCount(responseJson.data.total_results)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const handleOptionSelected = async (e, type) => {
        const { value } = e;
        const newFormData = { ...formData };
        newFormData[type] = value;
        setFormData(newFormData);
    }

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData[fieldName] = fieldValue;
        setFormData(newFormData);
    }

    const handleTimeChange = (date) => {
        setFrom(date ? dayjs(date[0]).format("YYYY-MM-DD") : '');
        setTo(date ? dayjs(date[1]).format("YYYY-MM-DD") : '')
    }

    const submit = () => {
        let check = true;
        if (check) {
            setLoadingModal(true);
            let data = {}
            if (formData.full_name) {
                data.full_name = formData.full_name
            }
            if (formData.email) {
                data.email = formData.email
            }
            if (formData.dob) {
                data.date_of_birth = formData.dob
            }
            if (formData.sponsorName) {
                data.upline_id = formData.sponsorName
            }
            if (formData.phoneNo) {
                data.telephone = formData.phoneNo
            }
            if (formData.country) {
                data.country = formData.country
            }
            if (formData.address) {
                data.address = formData.address
            }
            if (formData.ranking.toString()) {
                data.rank_id = Number(formData.ranking);
            }
            // if (formData.company_customer_profit_sharing_id) {
            //     data.company_customer_profit_sharing_id = Number(formData.company_customer_profit_sharing_id);
            // }
            // if(formData.max_lot_per_month){
            //     data.max_lot_per_month = Number(formData.max_lot_per_month);
            // }

            fetch(api.admin + `/edit_customer_profile/${formData.id}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        setModal(false)
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (responseJson.data && typeof responseJson.data.error === 'object') {
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key) => {
                                popupMessage.push(responseJson.data.error[key]);
                            })
                            swal(translate(props.lang, "Error"), popupMessage.join('\n'), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const openPurchaseModal = (data) => {
        setSelectedMember(data);
        setPurchaseModal(true);
    }

    const closePurchaseModal = () => {
        setSelectedMember(null);
        setPurchaseModal(false);
        resetForm();
    }

    const openAdjustCommModal = (data) => {
        setSelectedMember(data);
        setAdjustCommModal(true);
    }

    const closeAdjustCommModal = () => {
        setSelectedMember(null);
        setAdjustCommModal(false);
        resetForm();
    }

    const openTopupWalletModal = (data) => {
        setSelectedMember(data);
        setTopupWalletModal(true);
    }

    const submitProfit = () => {
        let check = true;
        let errorMsg = { ...errorsObj };
        if (profitFormData.total_commission_profit === '') {
            check = false;
            errorMsg.total_commission_profit = "This field is required.";
        }
        if (profitFormData.total_trade_profit === '') {
            check = false;
            errorMsg.total_trade_profit = "This field is required.";
        }
        setErrors(errorMsg);
        if (check) {
            setLoadingModal(true);
            fetch(api.tmp_manual_adjust_profit + `/${selectedMember.customer_id}`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(profitFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        closeAdjustCommModal();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const submitPackage = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        let newFormData = { ...purchaseFormData }
        if (!purchaseFormData.package_id) {
            errorMsg.package_id = 'This field is required.';
            check = false;
        }
        if (purchaseFormData.type === 'topup') {
            if (!purchaseFormData.customer_mt5_id) {
                errorMsg.customer_mt5_id = 'This field is required.';
                check = false;
            }
        }
        if (!purchaseFormData.amount) {
            errorMsg.amount = 'This field is required.';
            check = false;
        } else {
            if (purchaseFormData.type === 'create') {
                if (purchaseFormData.package_id) {
                    let filterPackage = packageList.filter(item => item.value === purchaseFormData.package_id);
                    if (filterPackage.length > 0) {
                        if (purchaseFormData.amount < filterPackage[0].min) {
                            errorMsg.amount = translate(props.lang, "Minimum investment amount is $amount").replace('$amount', filterPackage[0].min.toLocaleString('en-US'));
                            check = false;
                        } else {
                            if (filterPackage[0].max > 0) {
                                if (purchaseFormData.amount > filterPackage[0].max) {
                                    errorMsg.amount = translate(props.lang, "Maximum investment amount is $amount").replace('$amount', filterPackage[0].max.toLocaleString('en-US'));
                                    check = false;
                                }
                            } else {
                                newFormData.amount = Number(purchaseFormData.amount);
                            }
                        }
                    }
                }
            }
        }

        setErrors(errorMsg);
        if (check) {
            newFormData.amount = Number(purchaseFormData.amount);
            if (newFormData.type === 'create') {
                delete newFormData.customer_mt5_id;
            }
            if (newFormData.type === 'topup') {
                if (!newFormData.hedge_flag) {
                }
            }
            delete newFormData.package_id;
            setLoadingModal(true);
            fetch(api.tmp_manual_purchase_package + `/${selectedMember.customer_id}`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(newFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        closePurchaseModal();
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message === 'Token Expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const handleOptionFormSelected = async (e, type, formType) => {
        const { value } = e;
        if (formType === 'package') {
            const newFormData = { ...purchaseFormData };
            newFormData[type] = value;
            setPurchaseFormData(newFormData);
        } else if (formType === 'topup') {
            const newFormData = { ...topupWalletFormData };
            newFormData[type] = value;
            setTopupWalletFormData(newFormData);
        }
    }

    const handleFormChange = (event, formType) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        if (formType === 'package') {
            const newFormData = { ...formData };
            newFormData[fieldName] = fieldValue;
            setFormData(newFormData);
        } else if (formType === 'profit') {
            const newFormData = { ...profitFormData };
            newFormData[fieldName] = Number(fieldValue);
            setProfitFormData(newFormData);
        } else if (formType === 'topup') {
            const newFormData = { ...topupWalletFormData };
            newFormData[fieldName] = fieldValue;
            setTopupWalletFormData(newFormData);
        }
    }
    
    const getData = (data) => {
        fetch(api.get_customer_details + `/${data.customer_id}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    let dateObject = '';
                    if (responseJson.data.date_of_birth) {
                        // Split the date string into components

                        let dateParts = responseJson.data.date_of_birth.split('-');

                        // Extract the day, month, and year
                        let day = parseInt(dateParts[0], 10);
                        let month = parseInt(dateParts[1], 10) - 1; // Months are zero-indexed (0 = January, 11 = December)
                        let year = parseInt(dateParts[2], 10);
                        dateObject = new Date(year, month, day);
                    }

                    const newFormData = { ...formData };
                    newFormData.email = responseJson.data.email
                    newFormData.full_name = responseJson.data.full_name;
                    newFormData.referralCode = responseJson.data.referral_code
                    newFormData.phoneNo = responseJson.data.telephone
                    newFormData.address = responseJson.data.address;
                    newFormData.role = responseJson.data.role
                    newFormData.country = responseJson.data.country
                    newFormData.nickName = responseJson.data.nick_name;
                    newFormData.dob = responseJson.data.date_of_birth ? moment(dateObject).format('YYYY-MM-DD') : '';
                    newFormData.id = responseJson.data.customer_id
                    newFormData.sponsorName = responseJson.data.upline_id ? responseJson.data.upline_id : ""
                    newFormData.ranking = responseJson.data.manual_rank_id
                    newFormData.created_at = responseJson.data.date_added;
                    // newFormData.company_customer_profit_sharing_id = data.profit_sharing_id;
                    newFormData.max_lot_per_month = data.max_lot_per_month;
                    setFormData(newFormData)
                    handleSearch(responseJson.data.upline_name)
                    setModal(true);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log(translate(props.lang, "Error"), responseJson.message, "error");
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const setData = (data) => {
        const newFormData = { ...formData };
        newFormData.id = data.customer_id
        setFormData(newFormData)
    }

    const changeTrxPassword = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        if (!formData.trxPassword) {
            errorMsg.trxPassword = "This field is required.";
            check = false;
        }
        if (!formData.confirmTrxPassword) {
            errorMsg.confirmTrxPassword = "This field is required.";
            check = false;
        }

        if (formData.trxPassword !== formData.confirmTrxPassword) {
            errorMsg.confirmTrxPassword = "Confirm trx password need to same with new trx password";
            check = false;
        }
        setErrors(errorMsg);
        if (check) {
            setLoadingModal(true);
            let data = {
                "new_password": formData.trxPassword,
                "confirm_password": formData.confirmTrxPassword
            }
            fetch(api.reset_customer_transaction_password + `/${formData.id}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        setTrxModal(false);
                        resetForm();
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const changePassword = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        if (!formData.password) {
            errorMsg.password = "This field is required.";
            check = false;
        }
        if (!formData.confirmPassword) {
            errorMsg.confirmPassword = "This field is required.";
            check = false;
        }
        if (formData.password && formData.confirmPassword) {
            if (formData.confirmPassword !== formData.password) {
                errorMsg.confirmPassword = "Confirm login password need to same with new login password.";
                check = false;
            }
        }

        setErrors(errorMsg);
        if (check) {
            setLoadingModal(true);
            let data = {
                "new_password": formData.password.trim(),
                "confirm_password": formData.confirmPassword.trim()
            }
            fetch(api.reset_customer_password + `/${formData.id}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        resetForm();
                        setPasswordModal(false);
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const resetForm = () => {
        setErrors(errorsObj);
        setPurchaseFormData({
            amount: '',
            type: 'create',
            customer_mt5_id: '',
            package_id: '',
        })
        setTopupWalletFormData({ package_id: '', amount: '' });
        setProfitFormData({ total_trade_profit: '', total_commission_profit: '' });
        setFormData({
            nickName: '',
            username: '',
            trxPassword: '',
            confirmTrxPassword: '',
            email: '',
            role: '',
            id: '',
            referralCode: '',
            sponsorName: '',
            phoneNo: '',
            dob: '',
            ranking: '',
            remark: '',
            status: '',
            country: '',
            password: "",
            confirmPassword: "",
            created_at: "",
            dob: "",
            address: "",
            full_name: "",
            productPerpage: 10,
            packageId: "",
            totalProfit: 0,
            totalCommission: 0,
            status: '',
            // company_customer_profit_sharing_id: '',
            // max_lot_per_month: '',
        })
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Register Date": entry.date_add ? entry.date_add : '-',
                "Email": entry.email ? entry.email : '-',
                "Referral Code": entry.referral_code,
                "Referral By": entry.upline_name ? entry.upline_name : "-",
                "Auto Rank": entry.auto_rank_name ? entry.auto_rank_name : '-',
                "Manual Rank": entry.manual_rank_name ? entry.manual_rank_name : '-',
                "MT5 Balance": entry.mt5_balance ? Number(entry.mt5_balance).toLocaleString('en-US', digitFormat) : 0,
                "Wallet Balance": entry.wallet_balance ? Number(entry.wallet_balance).toLocaleString('en-US', digitFormat) : 0,
                "Self Deposit": entry.self_deposit ? Number(entry.self_deposit).toLocaleString('en-US', digitFormat) : 0,
                "Self Withdraw": entry.self_withdraw ? Number(entry.self_withdraw).toLocaleString('en-US', digitFormat) : 0,
                "Personal Sales": entry.personal_sales ? Number(entry.personal_sales).toLocaleString('en-US', digitFormat) : 0,
                "Group Sales": entry.group_sales ? Number(entry.group_sales).toLocaleString('en-US', digitFormat) : 0,
                "Remark": entry.is_dummy_account ? "Dummy Account" : '-',
                "Status": entry.status ? entry.status : '',
                "KYC Status": entry.kyc_status ? entry.kyc_status : "Not Verified",
                "KYC Remark": entry.kyc_remark ? entry.kyc_remark : '-',
                "Wallet Address TRC20": entry.customer_base58_address && entry.customer_base58_address.tron ? entry.customer_base58_address.tron : '',
                "Wallet Address BEP20": entry.customer_base58_address && entry.customer_base58_address.bsc ? entry.customer_base58_address.bsc : '',
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_customers + `?page=${pageCount}&sort_by=customer_id&order_by=DESC&limit=${exportPageSize}`
                if (email) {
                    url += `&email=${email}`;
                }
                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (status) {
                    url += `&status=${status}`
                }
                if (groupEmail) {
                    url += `&group_email=${groupEmail}`
                }
                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'member')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });

            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    const addMember = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        if (!formData.address) {
            errorMsg.address = "This field is required.";
            check = false;
        }
        if (!formData.trxPassword) {
            errorMsg.trxPassword = "This field is required.";
            check = false;
        }
        if (!formData.confirmTrxPassword) {
            errorMsg.confirmTrxPassword = "This field is required.";
            check = false;
        }
        if (formData.trxPassword && formData.confirmTrxPassword) {
            if (formData.trxPassword !== formData.confirmTrxPassword) {
                errorMsg.confirmTrxPassword = "Confirm password need to same with password";
                check = false;
            }
        }

        setErrors(errorMsg);
        if (check) {
            setLoadingModal(true);
            let data = {
                "nickname": formData.nickName,
                "country": formData.country,
                "address": formData.address, // wallet address,
                "transactionPassword": formData.trxPassword,
                "referTo": formData.referralCode ? formData.referralCode : ""
            }
            fetch(api.admin + `/add_member`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        resetForm();
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });


        }
    }

    const handleSearch = (e) => {
        if (e) {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                let url = api.get_customers + `?email=${e}&limit=${15}&page=${1}`;
                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang.toLowerCase(),
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        setTimeout(() => {
                            setLoading(false);
                        }, 500);
                        if (responseJson.status === "success") {
                            const members = responseJson.data.results.map(member => ({
                                value: member.customer_id,
                                label: member.email
                            }));
                            setMemberList(members);
                        }
                    });
            }, 500);
        }
    }

    const getRank = () => {
        fetch(api.get_rank, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token

            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    let arr = [];
                    arr.push({ value: 0, label: 'NO RANK' });
                    responseJson.data.map(item => (
                        arr.push({ value: item.rank_id, label: item.rank_name })
                    ));
                    setRankList(arr)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log(translate(props.lang, "Error"), responseJson.message, "error");
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const changeTab = (type) => {
        let newFormData = {
            package_id: '',
            type: type,
            customer_mt5_id: '',
            amount: ''
        };
        setErrors(errorsObj)
        setPurchaseFormData(newFormData);
    }

    const getOptionLabel = (option) => (
        option.value ? (
            <div className="d-flex w-100 align-items-center">
                <div className='text-end pe-1' style={{ minWidth: props.lang.toLowerCase() === 'en' ? '60px' : '45px' }}>
                    <span className="text-capitalize">{option.label}</span>
                </div>
                <div>
                    <span className="text-capitalize">({translate(props.lang, "Extra Profit")} {option.commission_rate}%)</span>
                </div>
            </div>
        ) : (
            <div className="text-center">
                <span className="mt-2 text-capitalize">{option.label}</span>
            </div>
        )
    )

    const closeTopupWalletModal = () => {
        setSelectedMember(null);
        setTopupWalletModal(false);
        resetForm();
    }

    const topupWallet = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        let newFormData = { ...topupWalletFormData }
        // if (!topupWalletFormData.package_id) {
        //     errorMsg.package_id = 'This field is required.';
        //     check = false;
        // } else {
        //     delete newFormData.amount;
        // }
        if (!topupWalletFormData.amount) {
            errorMsg.amount = 'This field is required.';
            check = false;
        } else {
            newFormData.amount = Number(topupWalletFormData.amount)
            delete newFormData.package_id;
        }

        setErrors(errorMsg);
        if (check) {
            setLoadingModal(true);
            fetch(api.tmp_deposit_to_customer + `/${selectedMember.customer_id}`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(newFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingModal(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        closeTopupWalletModal();
                        getMemberDetails();
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const viewMt5Account = (data) => {
        setSelectedMember(data);
        setMt5AccountModal(true);
    }

    const closeMt5AccountModal = () => {
        setSelectedMember(null);
        setMt5AccountModal(false);
    }

    const viewWalletAddress = (data) => {
        setSelectedMember(data);
        setWalletAddressModal(true)
    }

    const closeWalletAddressModal = () => {
        setSelectedMember(null);
        setWalletAddressModal(false);
    }

    const handlePackageForm = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
        const newFormData = { ...purchaseFormData };
        newFormData[fieldName] = fieldValue;
        setPurchaseFormData(newFormData);
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Personal (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value ? e.target.value : '')}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Group (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setGroupEmail(e.target.value ? e.target.value : '')}
                                                    value={groupEmail}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <RangePicker
                                                className="w-100 input-transparent"
                                                placeholder={[translate(props.lang, "From"), translate(props.lang, "To")]}
                                                onChange={(e) => handleTimeChange(e)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    statusList.length > 0 ? statusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Status")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={statusList.filter(item => item.value === status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) }))}
                                                name="status"
                                                isClearable
                                                onChange={(e) => setStatus(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                value={shownItem && shownItem.find(option => option.value === formData.productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerpage(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Register Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Member Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Referral Code")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Referral By")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Auto Rank")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Manual Rank")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Balance")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Wallet Balance")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Self Deposit")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Self Withdraw")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Personal Sales")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Group Sales")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Remark")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "KYC Status")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Wallet Address")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={17}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center`}>{(item.date_added)}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.email ? item.email : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.referral_code ? item.referral_code : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.upline_name ? item.upline_name : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.auto_rank_name ? item.auto_rank_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.manual_rank_name ? item.manual_rank_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.wallet_balance ? Number(item.wallet_balance).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.self_deposit ? Number(item.self_deposit).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.self_withdraw ? Number(item.self_withdraw).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.personal_sales ? Number(item.personal_sales).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.group_sales ? Number(item.group_sales).toLocaleString('en-US') : '0'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.is_dummy_account ? translate(props.lang, "Dummy Account") : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.status.toLowerCase() === "active" ? item.kyc_status ? item.kyc_status === 'Rejected' ? translate(props.lang, item.kyc_status) + " (" + item.kyc_remark + ")" : translate(props.lang, item.kyc_status) : translate(props.lang, "Not Verified") : item.status.toLowerCase() === "verified" ? translate(props.lang, "Verified") : translate(props.lang, "Not Verified")}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>
                                                            <Switch onChange={() => switchStatus(item.customer_id, item.status)} checked={item.status.toLowerCase() === "active" || item.status.toLowerCase() === "verified" ? true : false} />
                                                        </td>
                                                        <td className={`font-weight-500 font-16 text-center`}>
                                                            <button className="btnGrey py-2 text-center mx-auto px-4" onClick={() => { viewWalletAddress(item) }}>
                                                                <span className="btnText">{translate(props.lang, "View")}</span>
                                                            </button>
                                                        </td>

                                                        <td className={`font-weight-500 font-16 text-white`}>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4" onClick={() => getData(item)}>
                                                                <span className={`btnText`}>{translate(props.lang, "Edit")}</span>
                                                            </button>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => openPurchaseModal(item)}>
                                                                <span className={`btnText`}>{translate(props.lang, "Purchase Package")}</span>
                                                            </button>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => { openTopupWalletModal(item) }}>
                                                                <span className={`btnText`}>{translate(props.lang, "Topup Wallet")}</span>
                                                            </button>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => { setPasswordModal(true); setData(item) }}>
                                                                <span className={`btnText`}>{translate(props.lang, "Reset Login Password")}</span>
                                                            </button>
                                                            <button className="primary-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => { setTrxModal(true); setData(item) }}>
                                                                <span className={`btnText`}>{translate(props.lang, "Reset Trx Password")}</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={17}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-500 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal className="fade bgImgModal" show={modal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => { setModal(false); setButtonStatus("Cancel") }} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0">
                    <div className='modalBody px-0'>
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={12} md={12} sm={12} xs={12} className="px-0 mb-4">
                                <div className="text-center">
                                    <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Member Details")}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Registration Date")}</span>
                                <span className="font-18 font-weight-600 d-block text-black mt-2">{formData.created_at}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Name")}</span>
                                <div className={`groupLabel-input ${errors.full_name ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Name")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="full_name"
                                            value={formData.full_name}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.full_name)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Email")}</span>
                                <div className={`groupLabel-input ${errors.email ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Email")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="email"
                                            value={formData.email}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.email)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Sponsor Name")}</span>
                                <div className="input-group-select mt-1 mb-1">
                                    <Select
                                        options={
                                            memberList.length > 0
                                                ? memberList
                                                : [{ value: '', label: translate(props.lang, "No options available") }]
                                        }
                                        placeholder={translate(props.lang, "Select Sponsor Name")}
                                        className="input-transparent w-100 text-lowercase"
                                        classNamePrefix="customSelect"
                                        styles={customSelectStyles}
                                        value={formData.sponsorName ? memberList.length > 0 && memberList.find(option => option.value === formData.sponsorName) : ""}
                                        name="sponsorName"
                                        onInputChange={(e) => handleSearch(e)}
                                        onChange={(e) => handleOptionSelected(e, "sponsorName")}
                                    />
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Manual Rank")}</span>
                                <div className="input-group-select mt-1 mb-1">
                                    <div className="d-flex align-items-center">
                                        {customRankList.length > 0 ? (
                                            <Select
                                                options={
                                                    customRankList.length > 0 ? customRankList.map((item, i) => ({ key: i, value: item.rank_id, label: item.rank_name })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Select Ranking")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                classNamePrefix="customSelect"
                                                value={
                                                    formData.ranking.toString() ? (
                                                        customRankList.filter(item => item.rank_id === formData.ranking).length > 0 ?
                                                            (customRankList.filter(item => item.rank_id === formData.ranking).map((item, i) => ({ value: item.rank_id, label: item.rank_name, key: i })))
                                                            : null
                                                    ) : null
                                                }
                                                onChange={(e) => handleOptionSelected(e, "ranking")}
                                            />
                                        ) : (
                                            <Select
                                                options={
                                                    rankList.length > 0 ? rankList.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Select Ranking")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                classNamePrefix="customSelect"
                                                value={
                                                    formData.ranking.toString() ? (
                                                        rankList.filter(item => item.value == formData.ranking).length > 0 ?
                                                            (rankList.filter(item => item.value == formData.ranking).map((item, i) => ({ value: item.value, label: item.label, key: i })))
                                                            : null
                                                    ) : null
                                                }
                                                onChange={(e) => handleOptionSelected(e, "ranking")}
                                            />
                                        )}

                                    </div>
                                </div>
                            </Col>
                           
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Date of Birth")}</span>
                                <div className={`groupLabel-input ${errors.dob ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="input-group">
                                        <DatePicker
                                            className="w-100 mt-3 mt-md-0 input-transparent"
                                            placeholder={translate(props.lang, "Select Date Of Birth")}
                                            value={formData.dob ? dayjs(formData.dob) : undefined}
                                            onChange={(e) => handleDOBChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.dob)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Phone No")}</span>
                                <div className={`groupLabel-input ${errors.phoneNo ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Phone No")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="phoneNo"
                                            value={formData.phoneNo}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.phoneNo)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Country")}</span>
                                <div className={`input-group-select ${errors.country ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="d-flex align-items-center">
                                        <Select
                                            options={
                                                countries.length > 0 ? countries.map((item, i) => ({ value: item.name, label: item.name.toLowerCase() })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Select Country")}
                                            className="input-transparent w-100 text-capitalize"
                                            classNamePrefix="customSelect"
                                            styles={customSelectStyles}
                                            value={
                                                countries.filter(item => item.name == formData.country).length > 0 ?
                                                    (countries.filter(item => item.name == formData.country).map((item, i) => ({ value: item.name, label: item.name.toLowerCase() })))
                                                    : null
                                            }
                                            onChange={(e) => handleOptionSelected(e, "country")}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.country)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Address")}</span>
                                <div className={`groupLabel-textarea ${errors.address ? 'errorBorder' : ''} mt-1 mb-1`}>
                                    <div className="input-group" style={{ height: "10vh" }}>
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Address")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="address"
                                            value={formData.address}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.address)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => submit()} disabled={loadingModal}>
                                    <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={addMemberModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => { setAddMemberModal(false); resetForm() }} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0">
                    <div className='modalBody px-0'>
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={12} md={12} sm={12} xs={12} className="px-0 mb-4">
                                <div className="text-center">
                                    <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Add Member")}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Username")}</span>
                                <div className="groupLabel-input mt-1">
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Username")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="username"
                                            value={formData.username}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.username)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Country")}</span>
                                <div className="input-group-select mt-1">
                                    <div className="d-flex align-items-center">
                                        <Select
                                            options={
                                                countries.length > 0 ? countries.map((item, i) => ({ key: i, value: item.name, label: item.name })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Select Country")}
                                            className="input-transparent w-100 text-capitalize"
                                            classNamePrefix="customSelect"
                                            styles={customSelectStyles}
                                            value={
                                                countries.filter(item => item.name == formData.country).length > 0 ?
                                                    (countries.filter(item => item.name == formData.country).map((item, i) => ({ value: item.name, label: item.name })))
                                                    : null
                                            } name="country"
                                            onChange={(e) => handleOptionSelected(e, "country")}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.country)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Wallet Address")}</span>
                                <div className="groupLabel-input mt-2 mb-1">
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Wallet Address")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="address"
                                            value={formData.address}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.address)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Trx Password")}</span>
                                <div className={`groupLabel-input ${errors.trxPassword ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={showPassword ? "text" : "password"}
                                            placeholder={translate(props.lang, "Enter Trx Password")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="trxPassword"
                                            onChange={e => handleAddFormChange(e)}
                                            value={formData.trxPassword}

                                        />
                                        <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? (
                                                <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                            ) : (
                                                <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.trxPassword)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Confirm Trx Password")}</span>
                                <div className={`groupLabel-input ${errors.confirmTrxPassword ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={showConfirmPassword ? "text" : "password"}
                                            placeholder={translate(props.lang, "Enter Confirm Trx Password")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="confirmTrxPassword"
                                            onChange={e => handleAddFormChange(e)}
                                            value={formData.confirmTrxPassword}

                                        />
                                        <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                            {showConfirmPassword ? (
                                                <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                            ) : (
                                                <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.confirmTrxPassword)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Referral Code")}</span>
                                <div className="groupLabel-input mt-2">
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Referral Code")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="referralCode"
                                            value={formData.referralCode}
                                            onChange={e => handleAddFormChange(e)}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.referralCode)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => addMember()} disabled={loadingModal}>
                                    <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={purchaseModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closePurchaseModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='bgWhite h-100'>
                        <div className="px-0 px-md-4 h-100">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Purchase Package")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                    <div className="tab-container d-flex w-100 justify-content-start mb-3">
                                        <div className={`tab-item w-50 h-100 text-center px-4 py-3 buy ${purchaseFormData.type === 'create' ? 'active' : ""}`} onClick={() => changeTab('create')}>
                                            <span className="font-weight-600 font-16 text-capitalize">{translate(props.lang, "Transfer Package")}</span>
                                        </div>
                                        <div className={`tab-item w-50 h-100 text-center px-4 py-3 sell ${purchaseFormData.type === 'topup' ? 'active' : ""}`} onClick={() => changeTab('topup')}>
                                            <span className="font-weight-600 font-16 text-capitalize">{translate(props.lang, "Topup")}</span>
                                        </div>
                                    </div>
                                </Col>
                                {purchaseFormData.type === 'create' ? (
                                    <>
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3" >
                                            <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Copy Strategies")}</span>
                                            <div className={`input-group-select ${errors.package_id ? 'errorBorder' : ''} mt-1 mb-1`}>
                                                <div className="d-flex align-items-center">
                                                    <Select
                                                        options={
                                                            packageList.length > 0 ? packageList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No option available") }]
                                                        }
                                                        placeholder={translate(props.lang, 'Select Copy Strategies')}
                                                        className="input-transparent w-100 text-capitalize"
                                                        styles={customSelectStyles}
                                                        isSearchable={false}
                                                        value={
                                                            purchaseFormData.package_id ? packageList.filter(item => item.value === purchaseFormData.package_id).map((item) => ({ value: item.value, label: translate(props.lang, item.label) })) : ''
                                                        }
                                                        name="package_id"
                                                        onChange={(e) => handleOptionFormSelected(e, 'package_id', 'package')}
                                                    />
                                                </div>
                                            </div>
                                            <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.package_id)}</span>
                                        </Col>
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3" >
                                            <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Trading Profit (Month)")}</span>
                                            <div className="groupLabel-input mt-2">
                                                <div className={`input-group`}>
                                                    <Input
                                                        type={'text'}
                                                        className="form-control input-transparent py-1 px-3 text-lowercase"
                                                        value={purchaseFormData.package_id ? packageList.filter(item => item.value === purchaseFormData.package_id).length > 0 ? packageList.filter(item => item.value === purchaseFormData.package_id)[0].low_roi + `% ${translate(props.lang, "To")} ` + packageList.filter(item => item.value === purchaseFormData.package_id)[0].high_roi + "%" : '-' : '-'}
                                                        autoComplete="off"
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                ) : (
                                    <>
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3" >
                                            <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, 'MT5 Account')}</span>
                                            <div className={`input-group-select mt-1 mb-1 ${errors.package_id ? 'errorBorder' : ''}`}>
                                                <div className={`filter-input-group`}>
                                                    <Select
                                                        options={
                                                            selectedMember && selectedMember.mt5_accounts.length > 0 ? selectedMember.mt5_accounts.map((item, i) => ({ key: i, value: item.customer_mt5_id, label: `${translate(props.lang, "MT5 Account")} ${item.mt5_group_id} - ${item.mt5_login_id} ( ${translate(props.lang, "MT5 Balance")} : ${Number(item.mt5_balance).toLocaleString()} USD )` })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                        }
                                                        placeholder={translate(props.lang, 'Select MT5 Account')}
                                                        className="input-transparent w-100 text-capitalize"
                                                        styles={customSelectStyles}
                                                        isSearchable={false}
                                                        value={
                                                            purchaseFormData.customer_mt5_id && selectedMember ? selectedMember.mt5_accounts.filter(item => item.customer_mt5_id === purchaseFormData.customer_mt5_id).map((item) => ({ value: item.customer_mt5_id, label: `${translate(props.lang, "MT5 Account")} ${item.mt5_group_id} - ${item.mt5_login_id} ( ${translate(props.lang, "MT5 Balance")} : ${Number(item.mt5_balance).toLocaleString()} USD )` })) : ''
                                                        }
                                                        name="customer_mt5_id"
                                                        onChange={(e) => handleOptionFormSelected(e, "customer_mt5_id", 'package')}
                                                    />
                                                </div>
                                            </div>
                                            <div className='ms-0'>
                                                <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.package_id)}</span>
                                            </div>
                                        </Col>
                                    </>
                                )}
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Amount")}</span>
                                    <div className={`groupLabel-input mt-2 ${errors.amount ? 'errorBorder' : ''}`}>
                                        <div className="input-group">
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Amount")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="amount"
                                                value={purchaseFormData.amount}
                                                onChange={e => handlePackageForm(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className='ms-0'>
                                        <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.amount)}</span>
                                    </div>

                                </Col>
                                {/* {purchaseFormData.type === 'topup' ? (
                                    <div className="mb-3">
                                        <div className="form-check custom-checkbox d-flex align-items-center w-100 h-100">
                                            <input
                                                type="checkbox"
                                                className="form-check-input rememberMe-checkbox"
                                                id="customCheckBox1"
                                                checked={formData.hedge_flag}
                                                onChange={(e) => onChangeCheckbox(e)}
                                            />
                                            <label
                                                className={`form-check-label font-weight-500 font-13 text-grey-2 float-start ms-2 mb-0 pb-0`}
                                                htmlFor="customCheckBox1"
                                            >
                                                {translate(props.lang, "No hedging position")}
                                            </label>
                                        </div>
                                    </div>
                                ) : null} */}

                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
                                    <button className="primary-btn px-4 py-1 text-center mx-auto w-100" onClick={() => submitPackage()} disabled={loadingModal}>
                                        <span className={`font-weight-600 font-20 line-height-30 text-white`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={adjustCommModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeAdjustCommModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 ">
                    <div className='modalBody px-0'>
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={12} md={12} sm={12} xs={12} className="px-0 mb-4">
                                <div className="text-center">
                                    <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Adjust Profit")}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Total Profit")}</span>
                                <div className={`groupLabel-input ${errors.total_trade_profit ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={"number"}
                                            placeholder={translate(props.lang, "Enter Total Profit")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="total_trade_profit"
                                            onChange={e => handleFormChange(e, 'profit')}
                                            value={profitFormData.total_trade_profit}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.total_trade_profit)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Total Commission")}</span>
                                <div className={`groupLabel-input ${errors.total_commission_profit ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={"number"}
                                            placeholder={translate(props.lang, "Enter Total Commission")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="total_commission_profit"
                                            onChange={e => handleFormChange(e, 'profit')}
                                            value={profitFormData.total_commission_profit}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.total_commission_profit)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => submitProfit()} disabled={loadingModal}>
                                    <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={passwordModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => { setPasswordModal(false); resetForm() }} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 ">
                    <div className='modalBody px-0'>
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={12} md={12} sm={12} xs={12} className="px-0 mb-4">
                                <div className="text-center">
                                    <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Reset Login Password")}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "New Login Password")}</span>
                                <div className={`groupLabel-input ${errors.password ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={showPassword ? "text" : "password"}
                                            placeholder={translate(props.lang, "Enter New Login Password")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="password"
                                            onChange={e => handleAddFormChange(e)}
                                            value={formData.password}

                                        />
                                        <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? (
                                                <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                            ) : (
                                                <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.password)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Confirm New Login Password")}</span>
                                <div className={`groupLabel-input ${errors.confirmPassword ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type={showConfirmPassword ? "text" : "password"}
                                            placeholder={translate(props.lang, "Enter Confirm New Login Password")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="confirmPassword"
                                            onChange={e => handleAddFormChange(e)}
                                            value={formData.confirmPassword}
                                        />
                                        <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                            {showConfirmPassword ? (
                                                <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                            ) : (
                                                <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.confirmPassword)}</span>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => changePassword()} disabled={loadingModal}>
                                    <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                </button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={trxModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => { setTrxModal(false); resetForm() }} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center mb-3">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Reset Trx Password")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "New Trx Password")}</span>
                                    <div className={`groupLabel-input ${errors.trxPassword ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type={showTrxPassword ? "text" : "password"}
                                                placeholder={translate(props.lang, "Enter New Trx Password")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="trxPassword"
                                                onChange={e => handleAddFormChange(e)}
                                                value={formData.trxPassword}

                                            />
                                            <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowTrxPassword(!showTrxPassword)}>
                                                {showTrxPassword ? (
                                                    <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                ) : (
                                                    <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.trxPassword)}</span>

                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Confirm New Trx Password")}</span>
                                    <div className={`groupLabel-input ${errors.confirmTrxPassword ? 'errorBorder' : ''} mt-1 mb-1`}>
                                        <div className="input-group">
                                            <Input
                                                type={showConfirmTrxPassword ? "text" : "password"}
                                                placeholder={translate(props.lang, "Confirm New Trx Password")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="confirmTrxPassword"
                                                onChange={e => handleAddFormChange(e)}
                                                value={formData.confirmTrxPassword}
                                            />
                                            <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowConfirmTrxPassword(!showConfirmTrxPassword)}>
                                                {showConfirmTrxPassword ? (
                                                    <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                ) : (
                                                    <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.confirmTrxPassword)}</span>

                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                    <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => changeTrxPassword()} disabled={loadingModal}>
                                        <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={topupWalletModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeTopupWalletModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3 px-0">
                                    <div className="text-center">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Topup Wallet")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0" >
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Topup Wallet Amount")}</span>
                                    <div className={`groupLabel-input ${errors.amount ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                        <div className={`input-group`}>
                                            <Input
                                                type="number"
                                                name="amount"
                                                onWheel={event => event.currentTarget.blur()}
                                                placeholder={translate(props.lang, "Enter Topup Amount")}
                                                className="form-control input-transparent py-1 px-md-4 px-3"
                                                value={topupWalletFormData.amount}
                                                autoComplete="off"
                                                onChange={e => handleFormChange(e, 'topup')}
                                            />
                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.amount)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                    <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => topupWallet()} disabled={loadingModal}>
                                        <span className={`btnText`}>{loadingModal ? <FaSpinner /> : translate(props.lang, "Confirm")}</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={mt5AccountModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeMt5AccountModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='bgWhite h-100'>
                        <div className="px-0 px-md-4 h-100">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "MT5 Account")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                    <table>
                                        <tr>
                                            <td><span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Email")}</span></td>
                                            <td>
                                                <span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                <span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{selectedMember && selectedMember.email ? selectedMember.email : '-'}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Name")}</span></td>
                                            <td>
                                                <span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                <span className="font-weight-600 font-16 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{selectedMember ? selectedMember.full_name ? selectedMember.full_name : selectedMember.nick_name : '-'}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3" >
                                    <Table responsive className="w-100 table-list text-center position-relative">
                                        <thead>
                                            <tr>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Account")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Password")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Investment Allocation")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Contract Period")}</th>
                                                <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Extra Profit")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedMember && selectedMember.mt5_accounts ? (
                                                selectedMember.mt5_accounts.length > 0 ? (
                                                    selectedMember.mt5_accounts.map((item, i) => (
                                                        <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                            <td className={`font-weight-500 text-grey-2 font-16 text-center lh-base`}>{item.mt5_login_id}</td>
                                                            <td className={`font-weight-500 text-grey-2 font-16 text-center lh-base`}>{item.mt5_login_password}</td>
                                                            <td className={`font-weight-500 text-grey-2 font-16 text-center lh-base`}>{item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US') : 0}</td>
                                                            <td className={`font-weight-500 text-grey-2 font-16 text-center lh-base`}>{item.lock_days ? item.lock_days : 0} {translate(props.lang, "Days")}</td>
                                                            <td className={`font-weight-500 text-grey-2 font-16 text-center lh-base`}>{item.commission_rate ? item.commission_rate : '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr role="row" className={`even`}>
                                                        <td colspan={5}>
                                                            <span className="d-block text-grey-2 py-4">
                                                                {translate(props.lang, "Oops! No data found...")}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )
                                            ) : (
                                                <tr>
                                                    <td colspan={5}>
                                                        <span className="d-block text-grey-9 mt-4">
                                                            {translate(props.lang, "Oops! No data found...")}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={walletAddressModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeWalletAddressModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='bgWhite h-100'>
                        <div className="px-0 px-md-4 h-100">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Wallet Address")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <Row className="justify-content-center justify-content-md-start px-0 mx-0">
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-0">
                                            <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Email")}</span>
                                            <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedMember && selectedMember.email ? selectedMember.email : '-'}</span>
                                        </Col>
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                            <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Name")}</span>
                                            <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedMember ? selectedMember.full_name ? selectedMember.full_name : selectedMember.nick_name : '-'}</span>
                                        </Col>
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">

                                            {selectedMember && selectedMember.customer_base58_address ? (
                                                <>
                                                    <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "TRC20 Chain")}</span>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <a target="_blank" className="font-weight-600 font-18 text-black d-block" href={`https://tronscan.org/#/address/${selectedMember.customer_base58_address['tron']}/transfers`}>
                                                            <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedMember && selectedMember.customer_base58_address['tron'] ? selectedMember.customer_base58_address['tron'] : '-'}</span>
                                                        </a>
                                                    </div>
                                                    <span className={`font-weight-400 font-18 text-grey-9 d-block mt-3 mt-md-4`}>{translate(props.lang, "BEP20 Chain")}</span>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <a target="_blank" className="font-weight-600 font-18 text-black d-block" href={`https://bscscan.com/address/${selectedMember.customer_base58_address['bsc']}#tokentxns`}>
                                                            <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedMember && selectedMember.customer_base58_address['bsc'] ? selectedMember.customer_base58_address['bsc'] : '-'}</span>
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <span className={`font-weight-400 font-18 text-grey-9 d-block mt-3 mt-md-4`}>{translate(props.lang, "TRC20 Chain")}</span>
                                                    <span className={`font-weight-600 font-18 text-black d-block mt-2`}>-</span>

                                                    <span className={`font-weight-400 font-18 text-grey-9 d-block mt-3 mt-md-4`}>{translate(props.lang, "BEP20 Chain")}</span>
                                                    <span className={`font-weight-600 font-18 text-black d-block mt-2`}>-</span>
                                                </>
                                            )}

                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(MemberDetails);